import { BorderRadius, Checkbox, Color, DefaultValue, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const FilterOptionRow = styled(Checkbox)`
  width: 100%;
  padding: ${Spacing.S12};
  border-radius: ${DefaultValue.BorderRadius};

  &:hover {
    background-color: ${Color.Grey100};
  }
`

export const ChipTrigger = styled.button<{ isActive: boolean }>`
  display: inline-flex;
  box-sizing: border-box;
  align-items: center;
  gap: ${Spacing.S8};
  height: ${Spacing.S32};
  padding: ${Spacing.S4} ${Spacing.S12};
  border: 1px solid ${({ isActive }) => (isActive ? 'transparent' : Color.Grey200)};
  border-radius: ${BorderRadius.RFull};
  background: ${({ isActive }) => (isActive ? Color.Lavender100 : 'transparent')};
  cursor: pointer;

  &:hover {
    background: ${({ isActive }) => (isActive ? Color.Lavender200 : Color.Grey100)};
  }
`

export const ValuePreview = styled.span`
  max-width: ${Spacing.S80};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const PopoverCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: ${BorderRadius.R12};
  background: ${Color.White};
  overflow: hidden;
  ${getShadow('raisedStrong')};
`

export const PopoverBody = styled.div`
  padding: ${Spacing.S12};
`

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  padding: ${Spacing.S12};
  border-top: 1px solid ${Color.Grey100};

  & > * {
    flex: 1;
  }
`
